import { styled } from "@mui/system";
import { Button } from "@mui/material";

const PrimaryButton = styled(Button)(({ theme }) => ({
  "&&": {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    boxShadow: "none",
    minWidth: "6rem",
    padding: "0.85rem 1.5rem",
    fontWeight: theme.typography.fontWeightBold,
    textTransform: "none",

    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },

    "&:disabled": {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  },
}));

export default PrimaryButton;
